import React from "react"
import { graphql } from "gatsby"

import {
  Avatar,
  Box,
  Divider,
  Flex,
  Heading,
  PageWrapper,
  ShareMenu,
  SEO,
  Tags,
  Wrapper,
} from "components"

import ButtonBlock from "./_buttonBlock"
import TextBlock from "./_textBlock"
import QuoteBlock from "./_quote"
import Gallery from "./_gallery"
import Map from "./_map"
import FeaturedEvent from "./_featuredEvent"
import FeaturedBusiness from "./_featuredBusiness"

const AnnouncementTemplate = ({ loaderComplete, data }) => (
  <>
    <SEO
      title={data.page.title}
      description={data.page.excerpt}
      image={
        data.page.image &&
        data.page.image.url &&
        data.page.image.url +
          "?fit=crop&max-w=1200&h=" +
          1200 / (data.page.image.width / data.page.image.height)
      }
      imageAlt={data.page.image && data.page.image.alt}
    />

    <PageWrapper
      title={data.page.title}
      image={data.page.image}
      loaderComplete={loaderComplete}
      backButton="/about/news/"
      page={
        <>
          {/* Author and Sharing */}
          {data.page.author && data.page.author.name && (
            <Wrapper maxWidth={768} my={["layout.3", "layout.5"]}>
              <Flex alignItems="center">
                <Flex flex={1} alignItems="center">
                  <Avatar image={data.page.author.headshot} size={40} />
                  <Box ml="layout.1">
                    <Heading size={200}>
                      {"by "}
                      <Box as="span">{data.page.author.name}</Box>
                    </Heading>
                  </Box>
                </Flex>
                <Box ml="auto">
                  <ShareMenu />
                </Box>
              </Flex>
            </Wrapper>
          )}

          <Divider maxWidth={768} my={["layout.3", "layout.5"]} />

          {/* Content */}
          {data.page.content && (
            <Box as="section">
              <Box as="article">
                {data.page.content.map((block, index) => {
                  switch (block.__typename) {
                    case "DatoCmsTextBlock":
                      return (
                        <TextBlock content={block.body} key={"block" + index} />
                      )
                    case "DatoCmsButton":
                      return (
                        <ButtonBlock
                          link={block.link}
                          text={block.text}
                          key={"block" + index}
                        />
                      )
                    case "DatoCmsQuote":
                      return (
                        <QuoteBlock
                          quote={block.quote}
                          author={block.author}
                          key={"block" + index}
                        />
                      )
                    case "DatoCmsGallery":
                      return (
                        <Gallery images={block.images} key={"block" + index} />
                      )
                    case "DatoCmsFeaturedEvent":
                      return <FeaturedEvent event={block.event} />
                    case "DatoCmsFeaturedBusiness":
                      return <FeaturedBusiness business={block.business} />
                    case "DatoCmsMap":
                      return (
                        <Map
                          headline={block.headline}
                          coordinates={block.coordinates}
                          title={block.title}
                        />
                      )
                    default:
                      return null
                  }
                })}
              </Box>
            </Box>
          )}

          {data.page.experienceTypes &&
            data.page.experienceTypes.length > 0 && (
              <Tags tags={data.page.experienceTypes} />
            )}

          {/* <Divider /> */}

          {/* Other Things  */}
          {/* <Wrapper>
            <Heading size={700} mb="layout.4" textAlign={["left", "center"]}>
              Other things you may like
            </Heading>

            <FlexGrid
              content={[
                {
                  width: "33.333%",
                  children: <BusinessCard />,
                },
                { width: "33.333%", children: <EventCard /> },
                { width: "33.333%", children: <GuideCard /> },
              ]}
            />
          </Wrapper> */}
        </>
      }
    />
  </>
)

export default AnnouncementTemplate

export const query = graphql`
  query AnnouncementQuery($url: String!) {
    page: datoCmsAnnouncement(url: { eq: $url }) {
      title
      excerpt
      author {
        headshot {
          url
          width
          height
          alt
        }
        name
      }
      experienceTypes {
        experience
        url
      }
      image {
        url
        width
        height
        alt
      }
      content {
        __typename
        ... on DatoCmsTextBlock {
          body
        }
        ... on DatoCmsButton {
          link
          text
        }
        ... on DatoCmsQuote {
          quote
          author
        }
        ... on DatoCmsGallery {
          images {
            url
            width
            height
            alt
          }
        }
        ... on DatoCmsMap {
          headline
          coordinates {
            latitude
            longitude
          }
          title
        }
        ... on DatoCmsFeaturedBusiness {
          business {
            url
            name
            category {
              heroTitle
              url
            }
            address
            description
            featuredPhoto {
              url
              width
              height
              alt
            }
          }
        }
        ... on DatoCmsFeaturedEvent {
          event {
            url
            startDatetime
            endDatetime
            featuredPhoto {
              url
              width
              height
              alt
            }
            name
            experienceTypes {
              url
              experience
            }
            category {
              heroTitle
              url
            }
          }
        }
      }
    }
  }
`
